import { render, staticRenderFns } from "./ListExamDisp.vue?vue&type=template&id=27c94428&scoped=true&"
import script from "./ListExamDisp.vue?vue&type=script&lang=js&"
export * from "./ListExamDisp.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=27c94428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c94428",
  null
  
)

export default component.exports